import { useContext } from 'react';
import { userContext } from 'src/lib/store/userContext';
import { ComboBox } from '@carbon/react';
import { useApiFilterOptions } from 'src/lib/hooks/api';

export const KDFilter = (props) => {
  const { userState, userDispatch } = useContext(userContext);

  const filter = props.filter;

  const { options } = useApiFilterOptions(
    filter.id,
    filter.query.index,
    filter.query.body,
    filter.query.instances[0],
  );

  const handleFilterChange = (e) => {
    // update context in the global state
    userDispatch({
      type: 'SET_SELECTED_FILTER',
      payload: {
        filterId: filter.id,
        value: e.selectedItem,
      },
    });
  };

  return (
    <ComboBox
      id={ filter.id }
      titleText={ filter.label }
      placeholder={ `Select ${ filter.label }` }
      items={ options }
      itemToString={ option => (option ? option.text : '') }
      selectedItem={ userState.account.selectedFilters[filter.id] || {} }
      shouldFilterItem={ ({ item: { text }, inputValue }) => {
        if (text && inputValue) {
          return text?.toLowerCase().startsWith(inputValue?.toLowerCase());
        }
        return true;
      } }
      onChange={ e => handleFilterChange(e) }
    />
  );
};
